import styled from 'styled-components';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';
import Button from '../SolvPatternLibrary/Button';

export const Root = styled.div.withConfig({ componentId: 'sc-f43r53-0' })`
  display: flex;
  padding: 16px 8px;
  align-items: center;
  justify-content: left;
  background-color: ${colors.theWhiteAlbum};
  border: solid ${colors.borderLine};
  border-width: 1px 0;
  overflow: hidden;
`;

export const Close = styled.div.withConfig({ componentId: 'sc-f43r53-1' })`
  padding: 16px 16px 16px 8px;
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
  line-height: ${fontSize.default};
  height: 8px;
  width: 8px;
  background: url(/images/icons/x/large_grey.svg) no-repeat 8px center;
  background-size: 8px;
  cursor: pointer;
`;

export const Icon = styled.div.withConfig({ componentId: 'sc-f43r53-2' })`
  height: 57px;
  width: 57px;
  flex-shrink: 0;
  border-radius: 22.37%;
  background: url(/images/logo/solv-native-icon.png) no-repeat center;
  background-size: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 374px) {
    height: 40px;
    width: 40px;
  }
`;

export const IconInPhone = styled.img.withConfig({ componentId: 'sc-f43r53-3' })`
  height: 57px;
  flex-shrink: 0;
  padding-right: 8px;
  @media (max-width: 374px) {
    height: 40px;
  }
`;

export const Logo = styled.img.withConfig({ componentId: 'sc-f43r53-4' })`
  width: 40px;
`;

export const CopyContainer = styled.div.withConfig({ componentId: 'sc-f43r53-5' })`
  padding: 0 8px;
  flex-grow: 1;
  cursor: default;
  align-self: flex-start;
  height: 54px;

  > *:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const TitleCopy = styled.div.withConfig({ componentId: 'sc-f43r53-6' })`
  color: ${colors.blueMonday};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.mediumSmall};
  white-space: nowrap;
  @media (max-width: 374px) {
    font-size: ${fontSize.small};
  }
`;

export const SubTitleCopy = styled.div.withConfig({ componentId: 'sc-f43r53-7' })`
  color: ${colors.lightText};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.small};
  margin-top: 4px;
  @media (max-width: 374px) {
    font-size: ${fontSize.extraSmall};
    letter-spacing: -0.4px;
  }
`;

export const TryAppButton = styled(Button).withConfig({ componentId: 'sc-f43r53-8' })`
  &&& {
    height: unset;
    width: unset;
    min-width: unset;
    line-height: 1.15;
    font-family: ${fontFamily.medium};
    font-size: ${fontSize.small};
    letter-spacing: 0.11px;
    white-space: nowrap;
    padding: 8px;
    margin: 0 0 0 8px;
    flex-grow: 1;
    @media (max-width: 374px) {
      padding: 8px 4px;
    }
  }
`;
